import { render, staticRenderFns } from "./FacilityConfig.vue?vue&type=template&id=72b23743"
import script from "./FacilityConfig.vue?vue&type=script&lang=js"
export * from "./FacilityConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports